import styled from "styled-components";
import { useTheme } from "../middleware/ThemeContext";

interface StyleSkeletonProps {
  height?: string;
  width?: string;
  rounded?: boolean;

}

type SkeletonCellProps = React.HTMLAttributes<HTMLDivElement> & {
  height?: string;
  width?: string;
  rounded?: boolean;

};

export const SkeletonCell: React.FC<SkeletonCellProps> = ({ style, className, ...rest }) => {
  const { theme } = useTheme();
  return <StyleSkeletonCell theme={theme} style={style} className={className} {...rest} />;
};

export const StyleSkeletonCell = styled.div<StyleSkeletonProps>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height};
  border-radius: ${({ rounded }) => (rounded ? '50%' : '4px')};
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.skelletonBG};

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    height: 100%;
    width: 150%;
    background: linear-gradient(
      90deg,
      rgba(224, 224, 224, 0) 0%,
      rgba(245, 245, 245, 0.8) 50%,
      rgba(224, 224, 224, 0) 100%
    );
    animation: shimmer 1.2s ease-in-out infinite;
  }

  @keyframes shimmer {
    0% {
      left: -150%;
    }
    100% {
      left: 100%;
    }
  }
`;
